function mergeProps(userProps, injectedProps) {
    const merged = { ...userProps, ...injectedProps };
    Object.entries(merged).forEach(([key, value]) => {
        const typedKey = key;
        if (typedKey.indexOf('on') === 0) {
            if (typeof value === 'function') {
                merged[typedKey] = (...args) => {
                    return [injectedProps?.[typedKey], userProps?.[typedKey]]
                        .filter((v) => !!v)
                        .map((fn) => fn(...args))
                        .find((val) => val !== undefined);
                };
            }
        }
    });
    return merged;
}

export { mergeProps };
